import React, { createContext, useState, useContext } from 'react';
import { 
  MOCK_CLIENTS_FULL, 
  MOCK_CAMPAIGNS, 
  MOCK_COMPLIANCE_CASES, 
  MOCK_IB_TREE,
  STAFF_METRICS
} from '../data/mockData';

const CRMContext = createContext();

export const CRMProvider = ({ children }) => {
  // Global State Containers
  const [clients, setClients] = useState(MOCK_CLIENTS_FULL);
  const [campaigns, setCampaigns] = useState(MOCK_CAMPAIGNS);
  const [complianceCases, setComplianceCases] = useState(MOCK_COMPLIANCE_CASES);
  const [partners, setPartners] = useState(MOCK_IB_TREE);
  const [staffMetrics, setStaffMetrics] = useState(STAFF_METRICS);
  // Compliance Rules State
  const [bannedWords, setBannedWords] = useState(['guaranteed', 'risk-free', 'no loss', 'urgent', '100%']);
  // Global Overlay State
  const [selectedClient, setSelectedClient] = useState(null);
  // -- ACTIONS --

// 1. Marketing Actions
  const addCampaign = (campaign) => {
    // 1. Run "Agentic AI" Check
    const detectedIssues = [];
    const content = (campaign.creative?.headline + " " + campaign.creative?.body).toLowerCase();
    
    bannedWords.forEach(word => {
        if (content.includes(word.toLowerCase())) {
            detectedIssues.push(`Contains prohibited term: "${word}"`);
        }
    });

    // 2. Determine Status based on AI findings
    const finalStatus = detectedIssues.length > 0 ? 'Flagged' : 'Pending';
    const finalIssues = [...(campaign.issues || []), ...detectedIssues];

    // 3. Save
    setCampaigns([...campaigns, { 
        ...campaign, 
        id: Date.now(), 
        complianceStatus: finalStatus,
        issues: finalIssues
    }]);
  };

  const updateCampaignStatus = (id, status, complianceStatus) => {
    setCampaigns(prev => prev.map(c => 
      c.id === id ? { ...c, status, complianceStatus } : c
    ));
  };

  // 2. Compliance Actions
  const addComplianceCase = (newCase) => {
    setComplianceCases([newCase, ...complianceCases]);
  };

  const updateCaseStatus = (id, status) => {
    setComplianceCases(prev => prev.map(c => 
      c.id === id ? { ...c, status } : c
    ));
  };

  // 3. Client Actions
  const updateClientStatus = (clientId, newStatus) => {
    setClients(prev => prev.map(c => 
      c.id === clientId ? { ...c, status: newStatus } : c
    ));
  };

  return (
<CRMContext.Provider value={{
      // Data
      clients, campaigns, complianceCases, partners, staffMetrics, bannedWords, selectedClient,
      
      // Functions
      setClients, setCampaigns, setComplianceCases, setBannedWords, setSelectedClient,
      addCampaign, updateCampaignStatus,
      addComplianceCase, updateCaseStatus,
      updateClientStatus
    }}>
      {children}
    </CRMContext.Provider>
  );
};

export const useCRM = () => useContext(CRMContext);